export default "__VITE_ASSET__zXHFzYDm__$_?url__"